import type { HandlingUnit } from '../order/order.interface';
import { ObjectFactory } from './object.factory';

export class HandlingUnitFactory extends ObjectFactory<HandlingUnit> {
  protected getDefaults(): HandlingUnit {
    return {
      id: 'ffaabbccddeeff0011223344',
      quantity: 3,
      type: 'PAL',
    };
  }
}

export const handlingUnitFactory = new HandlingUnitFactory();
